export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      adminNoticeUuid: 'an003',
      title: ' 【メンテナンス情報】direct　2020年8月16日実施　臨時メンテナンスのお知らせ',
      message: '臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ臨時メンテナンスのお知らせ',
      signature: 'author',
      targetService: {
        serviceUuid: 'sv001',
        serviceName: 'xxxxx'
      },
      createdAt: 1594880785395,
      updatedAt: 1594880785395
    }
  }
}